var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCheckBgBlueMd = function SvgCheckBgBlueMd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0a9 9 0 1 0 9 9 9.01 9.01 0 0 0-9-9Zm5.195 6.15-5.133 6.967a.758.758 0 0 1-1.073.14l-3.666-2.93a.751.751 0 0 1 .938-1.172l3.057 2.446 4.67-6.338a.75.75 0 1 1 1.207.887Z",
    fill: "#3584C8"
  })));
};

export default SvgCheckBgBlueMd;